import ClubExamPart from './ClubExamPart';
import ClubExamType from './ClubExamType';
import Sport from '../offering/Sport';

export default class ClubExam {

    static EXAMINEE_TYPE_DOG = 'dog';
    static EXAMINEE_TYPE_MEMBER = 'member';

    constructor() {
        this.id = null;
        this.title = null;
        this.clubExamType = null;
        this.clubExamParts = [];
        this.sport = null;
        this.examineeType = null;
        this.archived = false;
        this.isArchivable = true;
        this.isDeletable = true;
        this.isEditable = true;
    }

    static fromData(data) {
        if (!data) {
            return;
        }

        let clubExam = new ClubExam();
        clubExam.id = data.id;
        clubExam.title = data.title;
        if (data.clubExamType) {
            clubExam.clubExamType = ClubExamType.fromData(data.clubExamType);
        }
        if (data.clubExamParts) {
            clubExam.clubExamParts = data.clubExamParts.map(data => ClubExamPart.fromData(data));
        }
        if (data.sport) {
            clubExam.sport = Sport.fromData(data.sport);
        }
        clubExam.examineeType = data.examineeType;
        clubExam.archived = data.archived;
        clubExam.isArchivable = data.isArchivable;
        clubExam.isDeletable = data.isDeletable;
        clubExam.isEditable = data.isEditable;

        return clubExam;
    }

    isForDogs() {
        return this.examineeType === ClubExam.EXAMINEE_TYPE_DOG;
    }

    serialize() {
        return {
            id: this.id,
            title: this.title,
            clubExamType: this.clubExamType !== null ? this.clubExamType.id : null,
            sport: this.sport !== null ? this.sport.id : null,
            examineeType: this.examineeType !== null ? this.examineeType.value : null,
            clubExamParts: this.clubExamParts.map(part => part.serialize()),
        }
    }
}
